import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { BankNotification } from '@features/banking/types'

import { bankNotificationsQueryKey } from '../queries/useBankNotificationsTable'

interface Variables {
  id: string
  reason: string
}

export function useIgnoreNotification() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, reason }: Variables): Promise<BankNotification> => {
      const res = await apiClient.post<BankNotification>(
        `${BACK_OFFICE_PREFIX}bank-notifications/${id}/ignore`,
        { reason }
      )
      return res.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: bankNotificationsQueryKey })
    }
  })
}
